module.exports = __webpack_public_path__ + "assets/img/05.faf81d15.png";